module.exports = __webpack_public_path__ + "e2e89fb8727d254107da03293f216694.svg";